import React from 'react';
import { ShieldCheck, Lock, Zap } from 'lucide-react';
export function TrustBadge() {
  return <div className="flex flex-col items-center justify-center gap-4 py-6 opacity-80" data-id="element-167">
      <div className="flex items-center gap-2 text-gray-400 text-sm mb-2" data-id="element-168">
        <Lock className="w-4 h-4" data-id="element-169" />
        <span data-id="element-170">Pago 100% seguro y encriptado</span>
      </div>

      <img src="https://cdn.magicpatterns.com/uploads/fu4N695oFmSJmEtqJnwqEB/ML.jpg" alt="Mercado Pago" className="h-8 object-contain grayscale hover:grayscale-0 transition-all duration-300 bg-white/10 p-1 rounded" data-id="element-171" />

      <div className="flex gap-6 text-xs text-gray-500 mt-2" data-id="element-172">
        <div className="flex items-center gap-1" data-id="element-173">
          <ShieldCheck className="w-3 h-3" data-id="element-174" />
          <span data-id="element-175">Datos protegidos</span>
        </div>
        <div className="flex items-center gap-1" data-id="element-176">
          <Zap className="w-3 h-3" data-id="element-177" />
          <span data-id="element-178">Acceso inmediato</span>
        </div>
      </div>
    </div>;
}